import { get, post, destroy } from '../lib/api';

export function getAllJobs() {
  return get('/admin/jobs');
}

export function runJob(queueName, data) {
  return post('/admin/jobs', { queue: queueName, data });
}

export function pauseQueue(queueName) {
  return post(`/admin/queues/${queueName}/paused`);
}

export function resumeQueue(queueName) {
  return destroy(`/admin/queues/${queueName}/paused`);
}

export function getJobs(queueName, type) {
  return get(`/admin/jobs/${queueName}/${type}`);
}

export function getJob(queueName, type, id) {
  return get(`/admin/jobs/${queueName}/${type}/${id}`);
}

export function removeJob(queueName, id) {
  return destroy(`/admin/jobs/${queueName}/${id}`);
}

export function redriveJob(queueName, id) {
  return post(`/admin/jobs/${queueName}/redrive/${id}`);
}

export function getQueues() {
  return get('/admin/queues');
}
